var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.7831 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Tablet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9796,2.1658h2.8238c.1992,0,.3606-.1615.3606-.3607s-.1614-.3607-.3606-.3607h-2.8238c-.1991.0002-.3605.1615-.3605.3607s.1614.3607.3605.3607Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9524,22.3957h-5.1218c-.0913,0-.1654.0741-.1654.1653,0,.0914.0741.1653.1654.1653h5.1218c.0914,0,.1654-.0739.1654-.1653,0-.0913-.0741-.1653-.1654-.1653Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5743,6.8517h-.1488V1.7857c0-.9623-.7801-1.7425-1.7424-1.7425H2.1001c-.9624,0-1.7424.7802-1.7424,1.7425v4.1687h-.1488C.0936,5.9544,0,6.0479,0,6.1631v1.566c0,.1153.0935.2087.2088.2087h.1488v.3405h-.1488C.0936,8.2783,0,8.3718,0,8.4872v1.5659c0,.1154.0935.2089.2088.2089h.1488v11.9524c0,.9623.7801,1.7423,1.7424,1.7423h12.583c.9623,0,1.7424-.78,1.7424-1.7423v-12.5197h.1488c.1153,0,.2088-.0935.2088-.2087v-2.4254c0-.1154-.0935-.2089-.2088-.2089h0ZM15.6837,22.1893c0,.5976-.4844,1.0821-1.0822,1.0821H2.1816c-.5977,0-1.0822-.4845-1.0822-1.0821V1.8374c0-.5976.4844-1.0821,1.0822-1.0821h12.42c.5977,0,1.0822.4845,1.0822,1.0821v20.3519h-.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.71aac7043f6ab5e90de2a33fb3013c56.svg";
export { ForwardRef as ReactComponent };